import http from '../http'

export default {
    all(usuario) {
        return http.get(`usuarios/${usuario}/cobranzas`)
    },

    update(usuario, cobranza, payload) {
        return http.put(`usuarios/${usuario}/cobranzas/${cobranza}`, payload)
    }
}